/*jshint esversion: 6 */
/*jshint strict: false */

import * as d3 from 'd3';

let data = [];

let colours = ['#FF5F5F', '#FF7761', '#FF8E61', '#FFAE64', '#F4CE2F', '#DAF230', '#98E230', '#39B54A', '#2CDDAE', '#2BCFE0', '#29ABE2'];

function setupGraph() {

    let svg = d3.select(".getting-worse .graph svg");

    svg.selectAll("*").remove();

    svg.attr('width', svg.node().getBoundingClientRect().width);
    svg.attr('height', svg.node().getBoundingClientRect().width / 1.8);

    let margin = {top: 50, right: 200, bottom: 30, left: 50},
        width = +svg.attr("width") - margin.left - margin.right,
        height = +svg.attr("height") - margin.top - margin.bottom,
        g = svg.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    let xScale = d3.scaleLinear().range([0, width]).domain([0.5, 7]);

    let yScale = d3.scaleLinear().range([height, 0]).domain([0, 10]);

    let tooltip = svg.select(function() { return this.parentNode; })
        .append("div")
        .attr("class", "tooltip")
        .style("opacity", 0);

    var gAxisX = g.append("g")
        .attr("class", "axis axis-x")
        .attr("transform", "translate(0," + height + ")")
        .call(d3.axisBottom(xScale).ticks(8));

    gAxisX.append("text")
        .attr('x', width + 20)
        .attr('y', 5)
        .text("Film in series");

    gAxisX.append("text")
        .attr('x', width / 2 - (margin.right - margin.left) )
        .attr('y', 30)
        .text("Hover over the chart to see the individual films");

    g.append("g")
        .attr("class", "axis axis-y")
        .call(d3.axisLeft(yScale).tickFormat(d3.format(".2f")))
        .append("text")
        .attr('x', -20)
        .attr('y', -20)
        .text("Score of each film");

    let gData = g.append("g")
        .attr('class', 'data');

    let gLegend = g.append("g")
        .attr('class', 'legend');

    let j = 1;
    for (let franchise in data) {

        let franchiseData = data[franchise];

        let lineImdb = d3.line()
            .x(function (d, i) {
                return xScale(i + 1);
            })
            .y(function (d) {
                return yScale(d.average);
            });

        gData.append("path")
            .datum(franchiseData)
            .style("stroke", function () {
                return colours[j];
            })
            .attr("d", lineImdb);

        gData.selectAll("circle.franchise-"+j)
            .data(franchiseData)
            .enter()
            .append('circle')
            .attr('class','franchise-'+j)
            .attr('r', 4)
            .attr("fill", function () {
                return colours[j];
            })
            .attr("cx", function (d, i) {
                return xScale(i + 1);
            })
            .attr("cy", function (d) {
                return yScale(d.average);
            })
            .on("mouseover", function (d) {
                tooltip.transition()
                    .duration(200)
                    .style("opacity", .9);
                tooltip.html(getTooltip(d))
                    .style("left", (d3.event.pageX) + "px")
                    .style("top", (d3.event.pageY - 28) + "px");
            })
            .on("mouseout", function () {
                tooltip.transition()
                    .duration(500)
                    .style("opacity", 0);
            });

        let legendItem = gLegend.append('g');

        legendItem
            .append('circle')
            .attr("fill", function () {
                return colours[j];
            })
            .attr('r', 4)
            .attr("cx", width + 20)
            .attr("cy", (height/2) - ((Object.keys(data).length / 2) * 20) + (j * 20) - 4);

        legendItem
            .append('text')
            .text(franchise)
            .attr("x", width + 30)
            .attr("y", (height/2) - ((Object.keys(data).length / 2) * 20) + (j * 20));

        j++;
    }

}

function getTooltip(d) {
    return d.title + '<br />' + d.average;
}

function populateTable() {

    let tableDiv = d3.select('.getting-worse .content-table');

    let template = tableDiv.select(".template").remove().node();

    for (let franchise in data) {

        let div = tableDiv.append(function () {
            return template.cloneNode(true);
        });
        div.classed("template", false);

        div.select('h3').text(franchise);

        let tbody = div.select('tbody');

        let tr = tbody.selectAll("tr")
            .data(data[franchise])
            .enter()
            .append("tr");

        tr.append("td").text(function (d) {
            return d.title;
        });

        tr.append("td").text(function (d) {
            return d.year;
        });

        tr.append("td").text(function (d) {
            return d.imdb;
        });

        tr.append("td").text(function (d) {
            return d.rottentomato + '%';
        });

        tr.append("td").text(function (d) {
            return d.average;
        });

    }

}

function loadData(dataDir) {

    let gettingWorse = ["Spy Kids", "Terminator", "Die Hard", "Ice Age", "Paranormal Activity", "Nightmare on Elm Street", "Pirates of the Caribbean", "Transformers", "Scary Movie", "Police Academy"];

    d3.csv(dataDir + "films.csv", function (csvData) {
        csvData.forEach(function (d) {

            if (gettingWorse.indexOf(d.franchise) >= 0) {

                d.year = +d.year;
                d.imdb = +d.imdb;
                d.rottentomato = +d.rottentomato.replace('%', '');
                //d.revenue = +d.revenue.replace(/[$,]+/g,"");

                d.average = ((d.imdb + (d.rottentomato / 10)) / 2).toFixed(2);

                if (!data.hasOwnProperty(d.franchise)) {
                    data[d.franchise] = [];
                }

                data[d.franchise].push(d);
            }
        });

        populateTable();
        setupGraph();
    });
}

function init(dataDir) {
    loadData(dataDir);
    window.addEventListener("resize", setupGraph);
}

export {init}


// WEBPACK FOOTER //
// ./getting-worse.js